import { render, staticRenderFns } from "./NFTCollectionView.vue?vue&type=template&id=16512316&scoped=true"
import script from "./NFTCollectionView.vue?vue&type=script&lang=ts"
export * from "./NFTCollectionView.vue?vue&type=script&lang=ts"
import style0 from "./NFTCollectionView.vue?vue&type=style&index=0&id=16512316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16512316",
  null
  
)

export default component.exports